export default function getTimeStamp(date?: string) {
  const now = date ? new Date(date) : new Date();
  const hours = now.getHours() % 12 || 12; // .toString().padStart(2, "0");
  const minutes = now.getMinutes().toString().padStart(2, '0');
  const period = now.getHours() >= 12 ? 'PM' : 'AM';
  const timeStamp = `${hours}:${minutes} ${period}`;
  return timeStamp;
}
